import { ServicePage } from "../components/ServicePage";
import { IMAGES, HOME_SERVICES } from "../lib/data";

export default function ConnexaHome() {
  return (
    <ServicePage
      testid="connexa-home-page"
      kicker="Connexa Home"
      title="Connexa Home"
      intro="La tua casa merita cura, non stress. Cerchiamo, trattiamo e organizziamo ogni dettaglio, così tu devi solo scegliere."
      heroImg={IMAGES.homeShowcase}
      services={HOME_SERVICES}
      gallery={[IMAGES.homeInterior1, IMAGES.homeInterior3, IMAGES.homeInterior2]}
      closingLine="Dalla ricerca alla consegna delle chiavi, restiamo al tuo fianco."
    />
  );
}
